<template>
    <el-dialog
    :show-close="false"
        :title="title"
        :visible="disableDialog"
        width="414px">
        <el-form label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="拒绝原因：">
                        {{mark}}
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
        <span slot="footer" class="dialog-center">
            <el-button type="primary" @click="onSubmit">确 定</el-button>

        </span>
    </el-dialog>
</template>
<script>

export default {
  inject: ['reload'],
  data () {
    return {
      mark: '',
      title: '',
      disableDialog: false,
      queryParams: {
        type: ''
      }
    }
  },
  methods: {
    // 审核不通过弹窗初始化
    onInitial (val, title) {
      this.mark = val
      this.title = title
      this.disableDialog = true
    },
    // 确定
    onSubmit () {
      this.disableDialog = false
      if (this.title === '审核驳回') {
        this.$emit('updatePurchaseApprovalState')
      } else {
        this.$emit('updatePurchase')
      }
    }
  }
}
</script>
